import React from 'react';

import { FacetContents } from '../../../resources/facetContents/domain/types/facetContents';
import { QuestionsAnswersAccordion } from '../../../shared/components/QuestionsAnswersAccordion/QuestionsAnswersAccordion';

type Props = {
    questionAnswers: FacetContents['questionAnswers'];
};

export function QuestionAnswers({ questionAnswers }: Props) {
    return (
        <div className="row">
            <div className="col-12 col-xl-8">
                <QuestionsAnswersAccordion questionsAnswers={questionAnswers} />
            </div>
        </div>
    );
}
